module.exports = __webpack_public_path__ + "static/media/S4N2-5.1d205034.svg";